export class ExamQuestion {
  id: number;
  question: string;
  userAnswer: string;
  score: number;
  feedback: string;
  examId: number;

  constructor(id: number, question: string, userAnswer: string, score: number, feedback: string, examId: number) {
    this.id = id;
    this.question = question;
    this.userAnswer = userAnswer;
    this.score = score;
    this.feedback = feedback;
    this.examId = examId;
  }

  public static constructExamQuestion(raw: any): ExamQuestion {
    return new ExamQuestion(
      raw.id,
      raw.question,
      raw.userAnswer,
      raw.score,
      raw.feedback,
      raw.examId
    );
  }
}